import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';

const DashboardPage = () => {
  return (
    <>
      <h2 className="mb-4">Dashboard</h2>
      <Row>
        <Col md={4}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Total Exhibitions</Card.Title>
              <Card.Text className="h2">15</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Total Photos</Card.Title>
              <Card.Text className="h2">150</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Recent Updates</Card.Title>
              <Card.Text className="h2">5</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DashboardPage;